export const Evolution = [
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-001",
    name: "Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-002",
    name: "Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-003",
    name: "Blackjack",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-004",
    name: "Dream Catcher",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-005",
    name: "Baccarat Squeeze",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-006",
    name: "Super Sic Bo",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-007",
    name: "First Person Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-008",
    name: "First Person Blackjack",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-009",
    name: "First Person Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-010",
    name: "First Person Dream Catcher",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-011",
    name: "First Person Lightning Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-012",
    name: "First Person Super Sic Bo",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-013",
    name: "First Person Dragon Tiger",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-014",
    name: "Speed Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-015",
    name: "Speed Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-016",
    name: "Blackjack VIP",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-017",
    name: "Baccarat VIP",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-018",
    name: "Super Sic Bo VIP",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-019",
    name: "Blackjack A (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-020",
    name: "Dragon Tiger (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-021",
    name: "First Person Blackjack (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-022",
    name: "First Person Dragon Tiger (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-023",
    name: "First Person Baccarat (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-024",
    name: "First Person Lightning Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-025",
    name: "Auto Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-026",
    name: "Lightning Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-027",
    name: "First Person Roulette (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-028",
    name: "Baccarat Squeeze VIP",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-029",
    name: "Baccarat A (Standard)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-030",
    name: "Baccarat C",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-031",
    name: "Craps",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-032",
    name: "Texas Hold'em Bonus Poker",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-033",
    name: "Three Card Poker",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-034",
    name: "Caribbean Stud Poker",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-035",
    name: "Poker (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-036",
    name: "Hold'em (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-037",
    name: "First Person Poker",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-038",
    name: "First Person Caribbean Stud Poker",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-039",
    name: "First Person Three Card Poker",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-040",
    name: "Auto Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-041",
    name: "First Person Lightning Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-042",
    name: "Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-043",
    name: "First Person Blackjack",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-044",
    name: "First Person Sic Bo",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-045",
    name: "First Person Roulette (5x)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-046",
    name: "Dream Catcher (Live)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-047",
    name: "Super 6 Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-048",
    name: "Blackjack A (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-049",
    name: "Craps VIP",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-050",
    name: "Speed Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-051",
    name: "Lightning Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-052",
    name: "European Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-053",
    name: "Football Studio",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-054",
    name: "Dragon Tiger VIP",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-055",
    name: "Speed Blackjack",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-056",
    name: "First Person Baccarat Squeeze",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-057",
    name: "Blackjack B (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-058",
    name: "Super Sic Bo VIP",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-059",
    name: "Baccarat VIP",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-060",
    name: "Baccarat Squeeze (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-061",
    name: "Blackjack C (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-062",
    name: "Speed Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-063",
    name: "Caribbean Stud Poker (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-064",
    name: "Blackjack A (Standard)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-065",
    name: "Lightning Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-066",
    name: "First Person Dream Catcher",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-067",
    name: "Roulette (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-068",
    name: "Speed Baccarat VIP",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-069",
    name: "Dragon Tiger A",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-070",
    name: "Baccarat A",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-071",
    name: "Super 6 Baccarat (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-072",
    name: "First Person Texas Hold'em",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-073",
    name: "Blackjack A (Standard)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-074",
    name: "Baccarat Squeeze VIP",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-075",
    name: "Texas Hold'em Bonus Poker (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-076",
    name: "Blackjack B",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-077",
    name: "Poker (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-078",
    name: "Roulette (European)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-079",
    name: "Blackjack A (Live)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-080",
    name: "Blackjack C",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-081",
    name: "First Person Caribbean Stud Poker",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-082",
    name: "First Person Craps",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-083",
    name: "First Person Baccarat Squeeze",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-084",
    name: "Live Poker",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-085",
    name: "Poker (Hold'em)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-086",
    name: "Blackjack A (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-087",
    name: "First Person Blackjack (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-088",
    name: "First Person Roulette (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-089",
    name: "First Person Lightning Roulette (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-090",
    name: "First Person Super Sic Bo",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-091",
    name: "Live Casino Hold'em",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-092",
    name: "Auto Blackjack",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-093",
    name: "Auto Roulette (5x)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-094",
    name: "First Person Craps (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-095",
    name: "Dragon Tiger",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-096",
    name: "Roulette (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-097",
    name: "European Roulette (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-098",
    name: "Baccarat Squeeze (Standard)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-099",
    name: "First Person Lightning Roulette (Standard)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-100",
    name: "First Person Baccarat Squeeze (VIP)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-101",
    name: "Lightning Dice",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-102",
    name: "First Person Blackjack (Standard)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-103",
    name: "First Person Roulette (Standard)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-104",
    name: "First Person Sic Bo",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-105",
    name: "First Person Dream Catcher",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-106",
    name: "Dream Catcher",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-107",
    name: "Speed Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-108",
    name: "Mega Wheel",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-109",
    name: "Lightning Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-110",
    name: "Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-111",
    name: "Auto Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-112",
    name: "Poker (Caribbean Stud)",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-113",
    name: "Hold'em",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-114",
    name: "Baccarat Squeeze",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-115",
    name: "Side Bet City",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-116",
    name: "Super Sic Bo",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-117",
    name: "Lightning Blackjack",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-118",
    name: "Golden Wealth Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-119",
    name: "Lightning Poker",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-120",
    name: "Speed Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-121",
    name: "Mega Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-122",
    name: "Baccarat 2",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-123",
    name: "Casino Hold'em",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-124",
    name: "Poker",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-125",
    name: "Texas Hold'em",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-126",
    name: "No Commission Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-127",
    name: "Baccarat Control Squeeze",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-128",
    name: "Speed Blackjack",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-129",
    name: "Dragons' Luck Megaways",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-130",
    name: "First Person Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-131",
    name: "Live Slots",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-132",
    name: "Lightning Wheel",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-133",
    name: "First Person Blackjack",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-134",
    name: "VIP Blackjack",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-135",
    name: "Ultimate Texas Hold'em",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-136",
    name: "Super Wheel",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-137",
    name: "No Commission Baccarat 2",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-138",
    name: "Quantum Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-139",
    name: "Mega Sic Bo",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-140",
    name: "Speed Baccarat H",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-141",
    name: "Speed Baccarat Q",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-142",
    name: "Speed Baccarat M",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-143",
    name: "Speed Baccarat X",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-144",
    name: "Speed Baccarat O",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-145",
    name: "Speed Baccarat A",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-146",
    name: "Speed Baccarat C",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-147",
    name: "Emperor Speed Baccarat B",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-148",
    name: "Speed Baccarat E",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-149",
    name: "Speed Baccarat P",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-150",
    name: "Emperor Speed Baccarat A",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-151",
    name: "Speed Baccarat K",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-152",
    name: "Speed Baccarat W",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-153",
    name: "Emperor Speed Baccarat C",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-154",
    name: "Speed Baccarat G",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-155",
    name: "Speed Baccarat L",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-156",
    name: "Speed Baccarat N",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-157",
    name: "Speed Baccarat J",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-158",
    name: "Speed Baccarat D",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-159",
    name: "Speed Baccarat 1",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-160",
    name: "Speed Baccarat 2",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-161",
    name: "Speed Baccarat 3",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-162",
    name: "Speed Baccarat R",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-163",
    name: "Speed Baccarat S",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-164",
    name: "Speed Baccarat T",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-165",
    name: "Speed Baccarat U",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-166",
    name: "Speed Baccarat V",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-167",
    name: "Speed Baccarat Z",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-168",
    name: "Extra Chili Epic Spins",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-169",
    name: "Imperial Quest",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-170",
    name: "Auto-Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-171",
    name: "Auto-Roulette VIP",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-172",
    name: "Bac Bo",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-173",
    name: "Speed Blackjack H",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-175",
    name: "Cash Or Crash",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-176",
    name: "Dead or Alive: Saloon",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-177",
    name: "Speed Blackjack D",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-178",
    name: "Fan Tan",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-179",
    name: "Golden Wealth Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-180",
    name: "Immersive Roulette",
  },

  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-181",
    name: "Lightning Blackjack",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-182",
    name: "Peek Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-183",
    name: "Funky Time",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-184",
    name: "Speed Blackjack E",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-185",
    name: "Speed Blackjack G",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-186",
    name: "Speed Blackjack I",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-187",
    name: "Speed Blackjack J",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-188",
    name: "Speed Blackjack K",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-189",
    name: "Speed Blackjack L",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-190",
    name: "Speed Blackjack M",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-191",
    name: "Speed VIP Blackjack A",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-192",
    name: "Speed VIP Blackjack B",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-193",
    name: "Speed VIP Blackjack C",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-194",
    name: "Speed VIP Blackjack D",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-195",
    name: "Speed VIP Blackjack E",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-196",
    name: "Speed VIP Blackjack F",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-197",
    name: "Speed VIP Blackjack G",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-198",
    name: "Speed VIP Blackjack H",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-199",
    name: "Speed VIP Blackjack I",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-200",
    name: "Speed VIP Blackjack J",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-201",
    name: "Speed VIP Blackjack K",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-202",
    name: "Speed VIP Blackjack L",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-203",
    name: "Speed VIP Blackjack M",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-204",
    name: "Super Andar Bahar",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-205",
    name: "XXXtreme Lightning Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-206",
    name: "First Person American Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-207",
    name: "First Person Lightning Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-208",
    name: "First Person Lightning Blackjack",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-209",
    name: "First Person Lightning Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-210",
    name: "Emperor Speed Baccarat D",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-211",
    name: "Emperor Sic Bo A",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-212",
    name: "Speed Auto Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-214",
    name: "Football Studio Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-215",
    name: "Salon Privé Blackjack A",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-216",
    name: "Salon Privé Blackjack B",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-217",
    name: "Salon Privé Blackjack C",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-218",
    name: "Salon Privé Blackjack D",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-219",
    name: "Salon Privé Blackjack E",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-220",
    name: "Salon Privé Blackjack F",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-221",
    name: "Salon Privé Blackjack G",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-222",
    name: "Salon Privé Blackjack H",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-223",
    name: "Salon Privé Blackjack I",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-224",
    name: "Salon Privé Blackjack J",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-225",
    name: "First Person Deal or No Deal",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-226",
    name: "First Person XXXtreme Lightning Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-227",
    name: "Video Poker",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-228",
    name: "Gold Vault Roulette",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-229",
    name: "Hindi Speed Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-230",
    name: "Emperor Bac Bo",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-231",
    name: "Bonsai Speed Baccarat A",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-232",
    name: "Bonsai Speed Baccarat B",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-233",
    name: "Bonsai Speed Baccarat C",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-234",
    name: "Blackjack VIP 28",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-235",
    name: "Blackjack VIP 29",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-236",
    name: "Salon Privé Baccarat K",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-237",
    name: "Salon Privé Baccarat L",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-238",
    name: "Speed VIP Blackjack N",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-239",
    name: "Speed VIP Blackjack O",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-240",
    name: "Speed VIP Blackjack P",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-241",
    name: "Speed VIP Blackjack Q",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-242",
    name: "Speed VIP Blackjack R",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-243",
    name: "Blackjack VIP 30",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-244",
    name: "First Person Prosperity Tree Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-245",
    name: "Prosperity Tree Baccarat",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-246",
    name: "Gonzo's Treasure Map",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-247",
    name: "Speed Baccarat 4",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-248",
    name: "Speed Baccarat 5",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-249",
    name: "Speed Baccarat 6",
  },
  {
    platform: "EVOLUTION",
    gameType: "LIVE",
    gameCode: "EVOLUTION-LIVE-250",
    name: "Speed Baccarat 9",
  },

  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-253",
    name: "Speed Baccarat 10",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-254",
    name: "Speed Baccarat 11",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-255",
    name: "XXXtreme Lightning Baccarat",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-256",
    name: "First Person XXXtreme Lightning Baccarat",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-257",
    name: "Red Door Roulette",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-258",
    name: "First Person Video Poker",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-259",
    name: "First Person Super Sic Bo",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-260",
    name: "Instant Super Sic Bo",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-261",
    name: "Crazy Pachinko",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-262",
    name: "Speed Baccarat 12",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-263",
    name: "Evo Speed Blackjack 1",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-264",
    name: "Evo Speed Blackjack 2",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-265",
    name: "Evo Speed Blackjack 3",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-266",
    name: "Evo Speed Blackjack 4",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-267",
    name: "Evo Speed Blackjack 5",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-268",
    name: "Evo Speed Blackjack 6",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-269",
    name: "Evo Speed Blackjack 7",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-270",
    name: "Evo Speed Blackjack 8",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-271",
    name: "Salon Privé Baccarat M",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-272",
    name: "Salon Privé Baccarat N",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-273",
    name: "Speed Baccarat 7",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-274",
    name: "Speed Baccarat 8",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-275",
    name: "Blackjack VIP 31",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-276",
    name: "Blackjack VIP 32",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-277",
    name: "Hindi Speed Baccarat B",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-278",
    name: "Evo Speed Blackjack 9",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-279",
    name: "Evo Speed Blackjack 10",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-280",
    name: "Evo Speed Blackjack 11",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-281",
    name: "Blackjack VIP 33",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-282",
    name: "Blackjack VIP 34",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-283",
    name: "Blackjack VIP 35",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-286",
    name: "Blackjack VIP 38",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-287",
    name: "Blackjack VIP 41",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-288",
    name: "Blackjack VIP 42",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-289",
    name: "Blackjack VIP 43",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-290",
    name: "Blackjack VIP 44",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-291",
    name: "Stock Market",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-292",
    name: "First Person Stock Market",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-314",
    name: "Free Bet VIP Blackjack A",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-315",
    name: "Free Bet VIP Blackjack B",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-332",
    name: "Blackjack VIP 36",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-333",
    name: "Blackjack VIP 37",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-334",
    name: "Blackjack VIP 45",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-335",
    name: "Blackjack VIP 46",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-336",
    name: "Blackjack VIP 47",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-337",
    name: "Blackjack VIP 48",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-338",
    name: "Blackjack VIP 49",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-344",
    name: "Lightning Dragon Tiger",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-362",
    name: "Lightning Sic Bo",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-363",
    name: "Balloon Race",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-364",
    name: "First Person HiLo",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-365",
    name: "Salon Privé Blackjack K",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-366",
    name: "Salon Privé Blackjack L",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-367",
    name: "Salon Privé Blackjack M",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-368",
    name: "Salon Privé Blackjack N",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-369",
    name: "Lightning Storm",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-376",
    name: "Lightning Ball",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-397",
    name: "Infinite Fun Fun 21 Blackjack",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-398",
    name: "Super Speed Baccarat",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-408",
    name: "Bet with Streamers",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-409",
    name: "Crazy Balls",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-410",
    name: "Always 8 Baccarat",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-411",
    name: "Lotus Sic Bo",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-412",
    name: "Infinite Bet Stacker Blackjack",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-413",
    name: "Easy Blackjack",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-414",
    name: "Emperor Golden Wealth Baccarat",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-415",
    name: "Thai Speed Baccarat A",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-416",
    name: "Lotus Speed Baccarat A",
  },
  {
    provider: "EVOLUTION",
    type: "LIVE",
    id: "EVOLUTION-LIVE-417",
    name: "Lotus Roulette",
  },
];

export const Fc = [
  {
    platform: "FC",
    gameType: "EGAME",
    gameCode: "FC-EGAME-001",
    name: "MONEY TREE DOZER",
  },
  {
    platform: "FC",
    gameType: "EGAME",
    gameCode: "FC-EGAME-002",
    name: "FA CHAI DOZER",
  },
  {
    platform: "FC",
    gameType: "EGAME",
    gameCode: "FC-EGAME-003",
    name: "CIRCUS DOZER",
  },
  {
    platform: "FC",
    gameType: "EGAME",
    gameCode: "FC-EGAME-004",
    name: "LIGHTNING BOMB",
  },
  {
    platform: "FC",
    gameType: "EGAME",
    gameCode: "FC-EGAME-005",
    name: "Super Color Game",
  },
  {
    platform: "FC",
    gameType: "EGAME",
    gameCode: "FC-EGAME-006",
    name: "GO GO RISE",
  },
  {
    platform: "FC",
    gameType: "EGAME",
    gameCode: "FC-EGAME-007",
    name: "MINES",
  },
  {
    platform: "FC",
    gameType: "EGAME",
    gameCode: "FC-EGAME-008",
    name: "TOWER",
  },
  {
    platform: "FC",
    gameType: "FH",
    gameCode: "FC-FISH-001",
    name: "MONKEY KING FISHING",
  },
  {
    platform: "FC",
    gameType: "FH",
    gameCode: "FC-FISH-002",
    name: "BAO CHUAN FISHING",
  },
  {
    platform: "FC",
    gameType: "FH",
    gameCode: "FC-FISH-004",
    name: "FIERCE FISHING",
  },
  {
    platform: "FC",
    gameType: "FH",
    gameCode: "FC-FISH-005",
    name: "STAR HUNTER",
  },
  {
    platform: "FC",
    gameType: "FH",
    gameCode: "FC-FISH-006",
    name: "GODS GRANT FORTUNE",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-001",
    name: "GOLDEN PANTHER",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-002",
    name: "THREE LITTLE PIGS",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-003",
    name: "HOT POT PARTY",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-004",
    name: "NIGHT MARKET",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-005",
    name: "PONG PONG HU",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-006",
    name: "PANDA DRAGON BOAT",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-007",
    name: "CHINESE NEW YEAR",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-008",
    name: "FORTUNE KOI",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-009",
    name: "HAPPY DUO BAO",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-010",
    name: "DA LE MEN",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-011",
    name: "ANIMAL RACING",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-012",
    name: "LUXURY GOLDEN PANTHER",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-013",
    name: "MAGIC BEANS",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-014",
    name: "COWBOYS",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-015",
    name: "WAR OF THE UNIVERSE",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-016",
    name: "TREASURE CRUISE",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-017",
    name: "GOLD RUSH",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-018",
    name: "RICH MAN",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-019",
    name: "GLORY OF ROME",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-020",
    name: "Robin Hood",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-021",
    name: "Lucky Fortunes",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-022",
    name: "CHINESE NEW YEAR 2",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-023",
    name: "GRAND BLUE",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-024",
    name: "TREASURE RAIDERS",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-025",
    name: "SUGAR BANG BANG",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-026",
    name: "CRAZY BUFFALO",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-027",
    name: "MERGE MAGIC",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-028",
    name: "GOLDEN GENIE",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-029",
    name: "ZEUS",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-030",
    name: "WIN WIN NEKO",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-031",
    name: "FORTUNE EGG",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-032",
    name: "NIGHT MARKET 2",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-033",
    name: "SUPER ELEMENTS",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-034",
    name: "LEGEND OF INCA",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-035",
    name: "EGYPT BONANZA",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-036",
    name: "CHILIHUAHUA",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-037",
    name: "FORTUNE SHEEP",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-038",
    name: "LUCKY FORTUNES 3x3",
  },
  {
    platform: "FC",
    gameType: "SLOT",
    gameCode: "FC-SLOT-039",
    name: "FORTUNE MONEY BOOM",
  },
];

export const Fastspin = [
  {
    platform: "FASTSPIN",
    gameType: "FH",
    gameCode: "FastSpin-FISH-001",
    name: "Fishing Treasure",
  },
  {
    platform: "FASTSPIN",
    gameType: "FH",
    gameCode: "FastSpin-FISH-002",
    name: "Ocean Carnival",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-001",
    name: "Royale House",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-002",
    name: "Sexy Vegas",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-003",
    name: "Roma",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-004",
    name: "Gold Rush Cowboy",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-005",
    name: "Wild Wet Win",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-006",
    name: "Royal Katt",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-007",
    name: "Rich Caishen",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-008",
    name: "Muay Thai Fighter",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-009",
    name: "Poker Ways",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-010",
    name: "Triple Happiness",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-011",
    name: "Lucky Fortune",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-012",
    name: "Fruits Mania",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-013",
    name: "Fiery Lava",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-014",
    name: "God of Wealth",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-015",
    name: "Legend of Eagle",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-016",
    name: "Neon Fantasy",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-017",
    name: "Space Conquest",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-018",
    name: "Loki",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-019",
    name: "Fortune Lions",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-020",
    name: "Honey Trap",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-021",
    name: "Oceanic Melodies",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-022",
    name: "The Maya Myth",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-023",
    name: "Spin and Win",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-024",
    name: "Safari Blitz",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-025",
    name: "Goddess Of Egypt",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-026",
    name: "Heavenly Fortunes 2",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-027",
    name: "Ganesha Luck",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-028",
    name: "Heavenly Fortunes",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-029",
    name: "Mining Bonanza",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-030",
    name: "The Nutcrackers",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-031",
    name: "Legend of Nian",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-032",
    name: "The Great Safari",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-033",
    name: "Tiki Rush",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-034",
    name: "Neko Riches",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-035",
    name: "Mighty Sevens",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-036",
    name: "Mushroom Bandit",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-037",
    name: "City of Jewels",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-038",
    name: "Sweet Frenzy",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-039",
    name: "Leprechaun Bonanza",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-040",
    name: "Money Empire",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-041",
    name: "Yeti Boom",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-042",
    name: "Ranger Showdown",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-043",
    name: "Money Dragon",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-044",
    name: "Adventure To The West",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-045",
    name: "Farm Of Fortune",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-046",
    name: "Caribbean Riches",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-047",
    name: "Mahjong Princess",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-048",
    name: "Pai Gow Ways",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-049",
    name: "Nezha",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-050",
    name: "Apollo Ray of Luck",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-051",
    name: "Pumpkins Go Lucky",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-052",
    name: "Beasts Of Luck",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-053",
    name: "Guardian of The Museum",
  },
  {
    platform: "FASTSPIN",
    gameType: "SLOT",
    gameCode: "FastSpin-SLOT-054",
    name: "Snake Treasure",
  },
];

export const GTF = [
  {
    platform: "GTF",
    gameType: "FH",
    gameCode: "GTF-FISH-001",
    name: "Fighting Fishing",
  },
  {
    platform: "GTF",
    gameType: "SLOT",
    gameCode: "GTF-SLOT-001",
    name: "Roma",
  },
  {
    platform: "GTF",
    gameType: "SLOT",
    gameCode: "GTF-SLOT-002",
    name: "Legend of Lion",
  },
  {
    platform: "GTF",
    gameType: "SLOT",
    gameCode: "GTF-SLOT-003",
    name: "Happy Songkran",
  },
  {
    platform: "GTF",
    gameType: "SLOT",
    gameCode: "GTF-SLOT-004",
    name: "Fireworks Festival",
  },
  {
    platform: "GTF",
    gameType: "SLOT",
    gameCode: "GTF-SLOT-005",
    name: "Adventure Island",
  },
  {
    platform: "GTF",
    gameType: "SLOT",
    gameCode: "GTF-SLOT-006",
    name: "Gummy Fever",
  },
  {
    platform: "GTF",
    gameType: "SLOT",
    gameCode: "GTF-SLOT-007",
    name: "The Third Prince",
  },
  {
    platform: "GTF",
    gameType: "SLOT",
    gameCode: "GTF-SLOT-008",
    name: "Sweet Fortune",
  },
  {
    platform: "GTF",
    gameType: "SLOT",
    gameCode: "GTF-SLOT-009",
    name: "Golden Ace",
  },
];

export const HorseBook = [
  {
    platform: "HORSEBOOK",
    gameType: "LIVE",
    gameCode: "HRB-LIVE-001",
    name: "Horsebook",
  },
];

export const iloveyou = [
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-001",
    name: "Jungle",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-002",
    name: "Crazy Monkey",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-003",
    name: "Qin",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-004",
    name: "Ocean",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-005",
    name: "Pyramid",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-006",
    name: "Pirate Ship",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-008",
    name: "Sango",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-009",
    name: "Christmas",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-010",
    name: "Aladdin",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-011",
    name: "White Snake",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-012",
    name: "Thai Paradise",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-013",
    name: "Thunder God",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-014",
    name: "Sparta",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-015",
    name: "God Of Fortune",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-016",
    name: "Safari Heat",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-017",
    name: "Panther Moon",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-018",
    name: "Great Blue",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-019",
    name: "Huga",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-020",
    name: "Beans Talk",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-021",
    name: "Money Bang Bang",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-022",
    name: "Dolphin Reef",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-023",
    name: "Three Kingdoms",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-024",
    name: "A Night Out",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-025",
    name: "Golden Lotus",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-026",
    name: "Penguin Vacation",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-027",
    name: "Highway Kings JP",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-028",
    name: "Robin Hood",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-029",
    name: "Monkey King slot",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-030",
    name: "God Of Wealth2",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-031",
    name: "Fortune Panda",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-032",
    name: "Hercules",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-033",
    name: "Queen",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-034",
    name: "African Wildlife",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-035",
    name: "Laura",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-036",
    name: "Seasons Greetings",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-037",
    name: "Big money",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-038",
    name: "Tree Of Fortune",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-039",
    name: "Fortune God",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-040",
    name: "Dragon Fortune",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-041",
    name: "Beer Party",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-042",
    name: "Legend Of Nezha",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-043",
    name: "Fortune Fuwa",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-044",
    name: "Fortune Tiger",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-045",
    name: "Queen Of Egypt",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-046",
    name: "Might Of Zeus",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-047",
    name: "FootBall Stars",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-048",
    name: "The Lion King",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-049",
    name: "Assassin",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-050",
    name: "Storm Estate",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-051",
    name: "Woodland",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-052",
    name: "Temple",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-053",
    name: "QinEmperor",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-054",
    name: "Treasure Bowl",
  },

  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-055",
    name: "Fruit 777",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-056",
    name: "West Journey",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-057",
    name: "Christmas Party",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-058",
    name: "Wall Street",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-059",
    name: "Gold Train",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-060",
    name: "Ocean Quest",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-061",
    name: "Mahjong Coming",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-062",
    name: "Super Ace",
  },
  {
    platform: "ILOVEU",
    gameType: "SLOT",
    gameCode: "ILOVEU-SLOT-063",
    name: "Master Ninja",
  },
];

export const JDB = [
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-001",
    name: "Crazy King Kong",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-002",
    name: "Lucky Color Game",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-003",
    name: "Birds and Animals",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-004",
    name: "Happy New Year",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-005",
    name: "CAISHEN PARTY",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-006",
    name: "King Of Football",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-007",
    name: "Super Super Fruit",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-008",
    name: "Huaguoshan Legends",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-009",
    name: "Classic Mario",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-010",
    name: "Beer Tycoon",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-011",
    name: "Jogo Do Bicho",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-012",
    name: "Galaxy Burst",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-013",
    name: "MINES",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-014",
    name: "FIREWORK BURST",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-015",
    name: "GOAL",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-016",
    name: "HILO",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-017",
    name: "Plinko",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-018",
    name: "Dice",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-019",
    name: "MINES 2",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-020",
    name: "Mole Crash",
  },
  {
    platform: "JDB",
    gameType: "EGAME",
    gameCode: "JDB-EGAME-022",
    name: "Aviator Extra Bet",
  },
  {
    platform: "JDB",
    gameType: "FH",
    gameCode: "JDB-FISH-008",
    name: "Cai Shen Fishing",
  },
  {
    platform: "JDB",
    gameType: "FH",
    gameCode: "JDB-FISH-009",
    name: "Shade Dragons Fishing",
  },
  {
    platform: "JDB",
    gameType: "FH",
    gameCode: "JDB-FISH-010",
    name: "Fishing YiLuFa",
  },
  {
    platform: "JDB",
    gameType: "FH",
    gameCode: "JDB-FISH-011",
    name: "Dragon Master",
  },
  {
    platform: "JDB",
    gameType: "FH",
    gameCode: "JDB-FISH-012",
    name: "Fishing Disco",
  },
  {
    platform: "JDB",
    gameType: "FH",
    gameCode: "JDB-FISH-013",
    name: "Fishing Legend",
  },
  {
    platform: "JDB",
    gameType: "FH",
    gameCode: "JDB-FISH-014",
    name: "Fighter Fire",
  },
  {
    platform: "JDB",
    gameType: "FH",
    gameCode: "JDB-FISH-015",
    name: "Dragon Fishing II",
  },
  {
    platform: "JDB",
    gameType: "FH",
    gameCode: "JDB-FISH-016",
    name: "Dragon Fishing",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-004",
    name: "Lucky Miner",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-009",
    name: "Beauty And The Kingdom",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-010",
    name: "Flirting Scholar Tang",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-011",
    name: "Winning Mask",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-012",
    name: "Wu kong",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-013",
    name: "Llama Adventure",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-014",
    name: "Formosa Bear",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-015",
    name: "Lucky Qilin",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-016",
    name: "New Year",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-017",
    name: "Four Treasures",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-018",
    name: "Open Sesame",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-019",
    name: "Banana Saga",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-020",
    name: "Olympian Temple",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-025",
    name: "Dragon",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-026",
    name: "Rooster In Love",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-027",
    name: "Monkey King",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-028",
    name: "Moonlight Treasure",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-029",
    name: "Mahjong",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-030",
    name: "Guan Gong",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-031",
    name: "Billionaire",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-032",
    name: "Dragon Warrior",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-033",
    name: "Kingsman",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-035",
    name: "RollingIn Money",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-036",
    name: "Chef Panda",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-039",
    name: "Mining Upstart",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-041",
    name: "Lucky Seven",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-042",
    name: "Orient Animals",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-043",
    name: "Triple King Kong",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-044",
    name: "Legendary 5",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-045",
    name: "Lucky Dragons",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-046",
    name: "Lucky Lion",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-048",
    name: "Napoleon",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-049",
    name: "Lucky Phoenix",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-050",
    name: "WinningMask II",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-051",
    name: "Open Sesame II",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-052",
    name: "Flirting Scholar Tang II",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-053",
    name: "Fortune Horse",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-054",
    name: "Xi Yang Yang",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-055",
    name: "Panda Panda",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-057",
    name: "Mr Bao",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-058",
    name: "One Punch Man",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-060",
    name: "Street Fighter",
  },
  { platform: "JDB", gameType: "SLOT", gameCode: "JDB-SLOT-063", name: "Daji" },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-065",
    name: "Lucky Racing",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-066",
    name: "Birds Party",
  },
  {
    platform: "JDB",
    gameType: "SLOT",
    gameCode: "JDB-SLOT-067",
    name: "Go Lai Fu",
  },
];

export const Jili = [
  {
    platform: "JILI",
    gameType: "FH",
    gameCode: "JILI-FISH-001",
    name: "Royal Fishing",
  },
  {
    platform: "JILI",
    gameType: "FH",
    gameCode: "JILI-FISH-002",
    name: "Bombing Fishing",
  },
  {
    platform: "JILI",
    gameType: "FH",
    gameCode: "JILI-FISH-003",
    name: "Jackpot Fishing",
  },
  {
    platform: "JILI",
    gameType: "FH",
    gameCode: "JILI-FISH-004",
    name: "Dinosaur Tycoon",
  },
  {
    platform: "JILI",
    gameType: "FH",
    gameCode: "JILI-FISH-005",
    name: "Happy Fishing",
  },
  {
    platform: "JILI",
    gameType: "FH",
    gameCode: "JILI-FISH-006",
    name: "Dragon Fortune",
  },
  {
    platform: "JILI",
    gameType: "FH",
    gameCode: "JILI-FISH-007",
    name: "Mega Fishing",
  },
  {
    platform: "JILI",
    gameType: "FH",
    gameCode: "JILI-FISH-008",
    name: "Boom Legend",
  },
  {
    platform: "JILI",
    gameType: "FH",
    gameCode: "JILI-FISH-009",
    name: "All-star Fishing",
  },
  {
    platform: "JILI",
    gameType: "FH",
    gameCode: "JILI-FISH-011",
    name: "Dinosaur Tycoon II",
  },
  {
    platform: "JILI",
    gameType: "FH",
    gameCode: "JILI-FISH-012",
    name: "Ocean King Jackpot",
  },
  {
    platform: "JILI",
    gameType: "FH",
    gameCode: "JILI-FISH-013",
    name: "Fortune King Jackpot",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-002",
    name: "Hot Chilli",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-003",
    name: "Chin Shi Huang",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-004",
    name: "War Of Dragons",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-005",
    name: "Fortune Tree",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-006",
    name: "Lucky Ball",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-007",
    name: "Hyper Burst",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-008",
    name: "Shanghai Beauty",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-009",
    name: "Fa Fa Fa",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-010",
    name: "God Of Martial",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-012",
    name: "Hawaii Beauty",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-013",
    name: "SevenSevenSeven",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-014",
    name: "Crazy777",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-015",
    name: "Bubble Beauty",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-016",
    name: "Bao boon chin",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-017",
    name: "Crazy FaFaFa",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-018",
    name: "XiYangYang",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-019",
    name: "FortunePig",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-020",
    name: "Candy Baby",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-021",
    name: "Diamond Party",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-022",
    name: "Fengshen",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-023",
    name: "Golden Bank",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-024",
    name: "Lucky Goldbricks",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-025",
    name: "Dragon Treasure",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-026",
    name: "Charge Buffalo",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-027",
    name: "Super Ace",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-028",
    name: "Jungle King",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-029",
    name: "Money Coming",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-030",
    name: "Golden Queen",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-031",
    name: "Boxing King",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-032",
    name: "Matka India",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-033",
    name: "Dice",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-034",
    name: "DragonTiger",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-035",
    name: "7 UP-DOWN",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-036",
    name: "Lucky Number",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-037",
    name: "Lucky Coming",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-038",
    name: "Pharaoh Treasure",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-039",
    name: "Secret Treasure",
  },

  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-040",
    name: "RomaX",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-041",
    name: "Super Rich",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-042",
    name: "Golden Empire",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-043",
    name: "Fortune Gems",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-044",
    name: "Party Night",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-045",
    name: "Crazy Hunter",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-046",
    name: "Magic Lamp",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-047",
    name: "TWIN WINS",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-048",
    name: "Agent Ace",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-049",
    name: "Alibaba",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-050",
    name: "Medusa",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-051",
    name: "Mega Ace",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-052",
    name: "Thor X",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-053",
    name: "Book of Gold",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-054",
    name: "Crazy Pusher",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-056",
    name: "Happy Taxi",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-057",
    name: "Gold Rush",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-058",
    name: "Mayan Empire",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-059",
    name: "Bone Fortune",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-060",
    name: "JILI CAISHEN",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-061",
    name: "Win Drop",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-062",
    name: "Bonus Hunter",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-063",
    name: "World Cup",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-070",
    name: "Samba",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-071",
    name: "Neko Fortune",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-072",
    name: "Wild Racer",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-073",
    name: "Pirate Queen",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-074",
    name: "Golden Joker",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-075",
    name: "Wild Ace",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-076",
    name: "Fortune Gems 2",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-077",
    name: "Master Tiger",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-078",
    name: "Cricket King 18",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-079",
    name: "Sweet Land",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-080",
    name: "Golden Temple",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-081",
    name: "Elf Bingo",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-082",
    name: "Cricket Sah 75",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-083",
    name: "Aztec Priestess",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-084",
    name: "Trial of Phoenix",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-085",
    name: "Devil Fire",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-086",
    name: "Bangla Beauty",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-087",
    name: "Fortune Monkey",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-088",
    name: "Dabanggg",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-089",
    name: "Sin City",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-090",
    name: "Night City",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-091",
    name: "King Arthur",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-092",
    name: "Arena Fighter",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-093",
    name: "Charge Buffalo Ascent",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-094",
    name: "Devil Fire 2",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-095",
    name: "Witches Night",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-096",
    name: "Fortune Gems 3",
  },

  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-097",
    name: "Zeus",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-098",
    name: "Potion Wizard",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-099",
    name: "Crazy Hunter 2",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-100",
    name: "Jackpot Joker",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-101",
    name: "3 Coin Treasures",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-102",
    name: "Super Ace Deluxe",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-103",
    name: "The Pig House",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-104",
    name: "Party Star",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-105",
    name: "Legacy of Egypt",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-106",
    name: "3 Pot Dragons",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-107",
    name: "Money Coming Expand Bets",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-108",
    name: "Egypt's Glow",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-109",
    name: "3 Lucky Piggy",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-110",
    name: "Shōgun",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-111",
    name: "Fruity Wheel",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-112",
    name: "Money Pot",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-113",
    name: "Nightfall Hunting",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-114",
    name: "Treasure Quest",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-115",
    name: "Lucky Jaguar",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-116",
    name: "Golden Bank 2",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-117",
    name: "Lucky Doggy",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-118",
    name: "Super Ace Joker",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-121",
    name: "Poseidon",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-122",
    name: "Coin Infinity",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-123",
    name: "Safari Mystery",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-124",
    name: "Roma X Deluxe",
  },
  {
    platform: "JILI",
    gameType: "SLOT",
    gameCode: "JILI-SLOT-125",
    name: "Coin Tree",
  },

  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-001",
    name: "Teen Patti",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-002",
    name: "AK47",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-003",
    name: "Andar Bahar",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-004",
    name: "Rummy",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-005",
    name: "NumberKing",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-006",
    name: "Poker King",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-007",
    name: "Big small",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-008",
    name: "iRich Bingo",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-009",
    name: "Callbreak",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-010",
    name: "TeenPatti Joker",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-011",
    name: "7up7down",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-012",
    name: "Dragon & Tiger",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-013",
    name: "Callbreak Quick",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-014",
    name: "Baccarat",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-015",
    name: "Fortune Bingo",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-016",
    name: "TeenPatti 20-20",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-017",
    name: "Sic Bo",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-018",
    name: "Super Bingo",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-019",
    name: "Bingo Carnaval",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-020",
    name: "Lucky Bingo",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-021",
    name: "Ludo Quick",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-022",
    name: "Go Goal Bingo",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-023",
    name: "Color Game",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-024",
    name: "Jackpot Bingo",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-025",
    name: "Tongits Go",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-026",
    name: "Calaca Bingo",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-027",
    name: "Golden Land",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-028",
    name: "PAPPU",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-029",
    name: "West Hunter Bingo",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-030",
    name: "Go Rush",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-031",
    name: "Tower",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-032",
    name: "HILO",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-033",
    name: "Mines",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-034",
    name: "Bingo Adventure",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-035",
    name: "Limbo",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-036",
    name: "wheel",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-037",
    name: "Mines Gold",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-038",
    name: "Pusoy Go",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-039",
    name: "Color Prediction",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-040",
    name: "Keno",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-041",
    name: "Plinko",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-042",
    name: "MINI FLUSH",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-043",
    name: "Candyland Bingo",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-044",
    name: "Blackjack",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-045",
    name: "Magic Lamp Bingo",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-046",
    name: "Blackjack Lucky Ladies",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-047",
    name: "Crash Bonus",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-048",
    name: "Pool Rummy",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-049",
    name: "Caribbean Stud Poker",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-050",
    name: "Video Poker",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-051",
    name: "Pearls of Bingo",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-052",
    name: "Jogo do Bicho",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-053",
    name: "European Roulette",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-054",
    name: "Speed Baccarat",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-055",
    name: "Crash Goal",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-056",
    name: "Jhandi Munda",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-057",
    name: "Fish Prawn Crab",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-058",
    name: "Crash Cricket",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-059",
    name: "Super Ace Scratch",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-060",
    name: "Cricket Roulette",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-061",
    name: "Ultimate Texas Hold'em",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-062",
    name: "Boxing Extravaganza",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-063",
    name: "Thai Hilo",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-064",
    name: "Super E-Sabong",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-065",
    name: "Keno Bonus Number",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-066",
    name: "Fortune Roulette",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-067",
    name: "Go For Champion",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-068",
    name: "Fortune Gems Scratch",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-069",
    name: "Cricket War",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-070",
    name: "Crash Touchdown",
  },
  {
    platform: "JILI",
    gameType: "TABLE",
    gameCode: "JILI-TABLE-071",
    name: "Keno Super Chance",
  },
];

//pending
export const Joker = [
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-001",
    name: "A Night Out",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-002",
    name: "Aladdin",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-003",
    name: "Alice",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-004",
    name: "Alice In Wonderland",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-005",
    name: "Ancient Artifact",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-006",
    name: "Ancient Egypt",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-007",
    name: "Ancient Rome Deluxe",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-008",
    name: "Archer",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-009",
    name: "Arctic Treasure",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-010",
    name: "Aztec Temple",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-011",
    name: "Azteca",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-012",
    name: "Bagua",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-013",
    name: "Bagua 2",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-014",
    name: "Bali",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-015",
    name: "Beach Life",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-016",
    name: "Beanstalk",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-017",
    name: "Big Game Safari",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-018",
    name: "Black Beard Legacy",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-019",
    name: "Bonus Bear",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-020",
    name: "Book Of Ra",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-021",
    name: "Book Of Ra Deluxe",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-022",
    name: "Bounty Hunter",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-023",
    name: "Buccaneer Deluxe",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-024",
    name: "Burning Pearl",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-025",
    name: "Bushido Blade",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-026",
    name: "Caishen Riches",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-027",
    name: "Captain's Treasure",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-028",
    name: "Captains Treasure Pro",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-029",
    name: "Captains Treasure Progressive",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-030",
    name: "Chilli Hunter",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-031",
    name: "China",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-032",
    name: "Chinese Boss",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-033",
    name: "Cluster Mania",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-034",
    name: "Columbus",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-035",
    name: "Critter Mania Deluxe",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-036",
    name: "Cryptomania",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-037",
    name: "Cursed Deluxe",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-038",
    name: "Cyber Race",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-039",
    name: "Dia De Los Muertos Deluxe",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-040",
    name: "Dolphin Reef",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-041",
    name: "Dolphin Treasure",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-042",
    name: "Dolphins Pearl Deluxe",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-043",
    name: "Dragon Of The Eastern Sea",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-044",
    name: "Dragon Phoenix",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-045",
    name: "Dragon Power Flame",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-046",
    name: "Dragon's Realm",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-047",
    name: "Dynamite Reels",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-048",
    name: "Egypt Queen",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-049",
    name: "Empress Regnant",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-050",
    name: "Enchanted Forest",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-051",
    name: "Enter The KTV",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-052",
    name: "Fabulous Eights",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-053",
    name: "Fat Choy Choy Sun",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-054",
    name: "Fei Long Zai Tian",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-055",
    name: "Feng Huang",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-056",
    name: "Fifty Dragons",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-057",
    name: "Fifty Lions",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-058",
    name: "Fire Reel",
  },
  {
    platform: "JOKER",
    gameType: "SLOT",
    gameCode: "JOKER-SLOT-059",
    name: "Fire Reign",
  },
];

export const KINGMAKER = [
  {
    platform: "KINGMAKER",
    gameType: "SLOT",
    gameCode: "KM-SLOT-001",
    name: "Sugar Blast",
  },
  {
    platform: "KINGMAKER",
    gameType: "SLOT",
    gameCode: "KM-SLOT-002",
    name: "Gems of Valhalla",
  },
  {
    platform: "KINGMAKER",
    gameType: "SLOT",
    gameCode: "KM-SLOT-003",
    name: "Sugar Blast Frenzy",
  },
  {
    platform: "KINGMAKER",
    gameType: "SLOT",
    gameCode: "KM-SLOT-004",
    name: "Cleopatra's Treasure",
  },
  {
    platform: "KINGMAKER",
    gameType: "SLOT",
    gameCode: "KM-SLOT-005",
    name: "Rooster Blitz",
  },
  {
    platform: "KINGMAKER",
    gameType: "SLOT",
    gameCode: "KM-SLOT-006",
    name: "Gold Mine",
  },
  {
    platform: "KINGMAKER",
    gameType: "SLOT",
    gameCode: "KM-SLOT-007",
    name: "ALMIGHTY GREEK",
  },
  {
    platform: "KINGMAKER",
    gameType: "SLOT",
    gameCode: "KM-SLOT-008",
    name: "WARRIORS TEMPLE",
  },
  {
    platform: "KINGMAKER",
    gameType: "SLOT",
    gameCode: "KM-SLOT-009",
    name: "LEPPY LOOT",
  },
  {
    platform: "KINGMAKER",
    gameType: "SLOT",
    gameCode: "KM-SLOT-010",
    name: "GOLD RUSH BONANZA",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-009",
    name: "thai-hi-lo2",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-010",
    name: "belangkai2",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-011",
    name: "dragon-tiger2",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-013",
    name: "fish-prawn-crab2",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-014",
    name: "vn_fish-prawn-crab",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-015",
    name: "sicbo",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-017",
    name: "taixiu",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-018",
    name: "keno",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-019",
    name: "thai-fpc",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-020",
    name: "Bài Cào",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-021",
    name: "NumberMatka",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-022",
    name: "CardMatka",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-023",
    name: "xocdia2",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-024",
    name: "FanTanClassic",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-025",
    name: "Fruit Roulette",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-026",
    name: "Baccarat",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-027",
    name: "european roulette",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-028",
    name: "7 Up 7 Down",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-029",
    name: "bai buu",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-030",
    name: "jhandimunda",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-032",
    name: "Andar Bahar",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-033",
    name: "Pai Kang",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-034",
    name: "KM Pok Deng",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-035",
    name: "Bola Golek",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-036",
    name: "Coin Toss",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-037",
    name: "Cards Hi Lo",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-038",
    name: "Blackjack",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-039",
    name: "32 Cards",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-040",
    name: "Plinko",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-041",
    name: "Cash Rocket",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-042",
    name: "Minesweeper",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-043",
    name: "Bonus Dice",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-044",
    name: "Dota Hi-Lo",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-045",
    name: "Monkey King Roulette",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-046",
    name: "Teen Patti",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-047",
    name: "Heist",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-048",
    name: "HorseRacing",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-049",
    name: "5 Card Poker",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-050",
    name: "Colour Game",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-051",
    name: "KM Power Ball",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-052",
    name: "BolaTangkas",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-053",
    name: "Marble Knockout",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-055",
    name: "KM Virtual Greyhound Racing",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-058",
    name: "KM Virtual Treadmill Racing",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-060",
    name: "Ludo",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-062",
    name: "KM Virtual Animal Race",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-063",
    name: "Tongits",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-065",
    name: "Pusoy",
  },
  {
    platform: "KINGMAKER",
    gameType: "TABLE",
    gameCode: "KM-TABLE-066",
    name: "Coin Pusher",
  },
];

export const Sexy = [
  {
    platform: "SEXYBCRT",
    gameType: "LIVE",
    gameCode: "MX-LIVE-001",
    name: "Baccarat Classic",
  },
  {
    platform: "SEXYBCRT",
    gameType: "LIVE",
    gameCode: "MX-LIVE-002",
    name: "Baccarat",
  },
  {
    platform: "SEXYBCRT",
    gameType: "LIVE",
    gameCode: "MX-LIVE-006",
    name: "DragonTiger",
  },
  {
    platform: "SEXYBCRT",
    gameType: "LIVE",
    gameCode: "MX-LIVE-009",
    name: "Roulette",
  },
  {
    platform: "SEXYBCRT",
    gameType: "LIVE",
    gameCode: "MX-LIVE-011",
    name: "2020 Teen Patti",
  },
  {
    platform: "SEXYBCRT",
    gameType: "LIVE",
    gameCode: "MX-LIVE-012",
    name: "Extra Andar Bahar",
  },
  {
    platform: "SEXYBCRT",
    gameType: "LIVE",
    gameCode: "MX-LIVE-014",
    name: "Thai Hi Lo",
  },
  {
    platform: "SEXYBCRT",
    gameType: "LIVE",
    gameCode: "MX-LIVE-015",
    name: "Thai Fish Prawn Crab",
  },
  {
    platform: "SEXYBCRT",
    gameType: "LIVE",
    gameCode: "MX-LIVE-016",
    name: "Extra Sicbo",
  },
  {
    platform: "SEXYBCRT",
    gameType: "LIVE",
    gameCode: "MX-LIVE-017",
    name: "Sedie",
  },
];
export const PP = [
  {
    platform: "PP",
    gameType: "EGAME",
    gameCode: "PP-EGAME-001",
    name: "Spaceman",
  },
  {
    platform: "PP",
    gameType: "EGAME",
    gameCode: "PP-EGAME-002",
    name: "Penalty Shootout",
  },
  {
    platform: "PP",
    gameType: "EGAME",
    gameCode: "PP-EGAME-003",
    name: "Horse Racing",
  },
  {
    platform: "PP",
    gameType: "EGAME",
    gameCode: "PP-EGAME-004",
    name: "Fantastic League",
  },
  {
    platform: "PP",
    gameType: "EGAME",
    gameCode: "PP-EGAME-005",
    name: "Greyhound Racing",
  },
  {
    platform: "PP",
    gameType: "EGAME",
    gameCode: "PP-EGAME-006",
    name: "Force 1",
  },
  {
    platform: "PP",
    gameType: "EGAME",
    gameCode: "PP-EGAME-007",
    name: "Darts",
  },
  {
    platform: "PP",
    gameType: "EGAME",
    gameCode: "PP-EGAME-008",
    name: "High Flyer",
  },
  {
    platform: "PP",
    gameType: "EGAME",
    gameCode: "PP-EGAME-009",
    name: "Big Bass Crash",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "L-PP-LIVE-007",
    name: "Baccarat 8",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "L-PP-LIVE-008",
    name: "Speed Baccarat 15",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "L-PP-LIVE-010",
    name: "Baccarat 3",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "L-PP-LIVE-022",
    name: "Speed Baccarat 11",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "L-PP-LIVE-023",
    name: "Speed Baccarat 12",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "L-PP-LIVE-024",
    name: "Speed Baccarat 13",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "L-PP-LIVE-037",
    name: "Roulette Ruby",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "L-PP-LIVE-041",
    name: "ONE Blackjack 2 - Ruby",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "L-PP-LIVE-077",
    name: "Lucky 6 Roulette",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "L-PP-LIVE-079",
    name: "Sic Bo",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-001",
    name: "Baccarat 1",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-002",
    name: "Baccarat 2",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-003",
    name: "Speed Baccarat 14",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-004",
    name: "Baccarat 5",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-005",
    name: "Baccarat 6",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-006",
    name: "Baccarat 7",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-007",
    name: "Baccarat 8",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-008",
    name: "Speed Baccarat 15",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-010",
    name: "Baccarat 3",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-013",
    name: "Speed Baccarat 1",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-014",
    name: "Speed Baccarat 2",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-015",
    name: "Speed Baccarat 3",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-016",
    name: "Speed Baccarat 5",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-017",
    name: "Speed Baccarat 6",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-018",
    name: "Speed Baccarat 7",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-019",
    name: "Speed Baccarat 8",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-020",
    name: "Speed Baccarat 9",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-021",
    name: "Speed Baccarat 10",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-022",
    name: "Speed Baccarat 11",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-023",
    name: "Speed Baccarat 12",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-024",
    name: "Speed Baccarat 13",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-025",
    name: "Mega Sic Bo",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-026",
    name: "Auto-Roulette",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-027",
    name: "Speed Roulette 1",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-028",
    name: "Roulette Azure",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-029",
    name: "Roulette Green",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-030",
    name: "Russian Roulette",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-031",
    name: "German Roulette",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-032",
    name: "Roulette Italia Tricolore",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-033",
    name: "Turkish Roulette",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-034",
    name: "Roulette Macao",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-035",
    name: "Roulette Indian",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-036",
    name: "VIP Roulette - The Club",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-037",
    name: "Roulette Ruby",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-038",
    name: "Mega Wheel",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-039",
    name: "Mega Roulette",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-040",
    name: "One Blackjack",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-041",
    name: "ONE Blackjack 2 - Ruby",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-042",
    name: "Dragon Tiger",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-043",
    name: "Andar Bahar",
  },

  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-044",
    name: "Sweet Bonanza Candyland",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-045",
    name: "Super 8 Baccarat",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-047",
    name: "Fortune 6 Baccarat",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-048",
    name: "Romanian Roulett",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-049",
    name: "Boom City",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-050",
    name: "Speed Baccarat 16",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-051",
    name: "Speed Baccarat 17",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-052",
    name: "Baccarat 9",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-053",
    name: "Spanish Roulette",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-054",
    name: "Speed Roulette 2",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-055",
    name: "PowerUp Roulette",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-056",
    name: "Korean Speed Baccarat 1",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-057",
    name: "Korean Speed Baccarat 2",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-059",
    name: "ONE Blackjack 5 - Turkish",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-060",
    name: "Speed Auto-Roulette 1",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-061",
    name: "Mega Baccarat",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-062",
    name: "Snakes & Ladders Live",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-068",
    name: "Vietnamese Roulette",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-069",
    name: "Thai Speed Baccarat 1",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-070",
    name: "Korean Speed Baccarat 3",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-071",
    name: "Korean Speed Baccarat 4",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-072",
    name: "Indonesian Speed Baccarat 1",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-073",
    name: "Korean Roulette",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-074",
    name: "Brazilian Roulette",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-075",
    name: "Auto Mega Roulette",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-076",
    name: "Vegas Ball Bonanza",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-077",
    name: "Lucky 6 Roulette",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-079",
    name: "Sic Bo",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-080",
    name: "Chinese Speed Baccarat 1",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-081",
    name: "Turkish Mega Roulette",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-082",
    name: "Blackjack X 1 - Azure",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-083",
    name: "Blackjack X 2 - Azure",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-084",
    name: "Blackjack X 3 - Azure",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-085",
    name: "Blackjack X 4 - Ruby",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-086",
    name: "Blackjack X 5 - Ruby",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-087",
    name: "Blackjack X 6 - Azure",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-088",
    name: "Blackjack X 7 - Azure",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-089",
    name: "Blackjack X 8 - Ruby",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-090",
    name: "Blackjack X 9 - Ruby",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-091",
    name: "Blackjack X 10 - Ruby",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-092",
    name: "Blackjack X 14 - Ruby",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-093",
    name: "Blackjack X 15 - Ruby",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-094",
    name: "Blackjack X 16 - Azure",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-095",
    name: "Blackjack X 17 - Azure",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-096",
    name: "Blackjack X 18 - Azure",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-097",
    name: "Blackjack X 19 - Ruby",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-098",
    name: "Blackjack X 20 - Ruby",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-099",
    name: "Japanese Speed Baccarat 3",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-103",
    name: "BlackjackX 30 - Emerald",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-104",
    name: "BlackjackX 29 - Emerald",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-105",
    name: "BlackjackX 28 - Emerald",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-106",
    name: "BlackjackX 27 - Emerald",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-107",
    name: "BlackjackX 26 - Emerald",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-108",
    name: "BlackjackX 23 - Emerald",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-109",
    name: "BlackjackX 22 - Emerald",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-110",
    name: "BlackjackX 13 - Emerald",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-111",
    name: "BlackjackX 12 - Emerald",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-112",
    name: "BlackjackX 11 - Emerald",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-113",
    name: "Korean Speed Baccarat 6",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-114",
    name: "Chinese Speed Baccarat 2",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-115",
    name: "Vietnamese Speed Baccarat 1",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-116",
    name: "Punto Banco Italia Tricolore",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-117",
    name: "Korean Speed Baccarat 5",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-118",
    name: "Japanese Speed Baccarat 1",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-119",
    name: "Japanese Speed Baccarat 2",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-120",
    name: "BlackjackX 21 - Ruby",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-121",
    name: "BlackjackX 24 - Azure",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-122",
    name: "BlackjackX 25 - Azure",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-123",
    name: "Football Blitz Top Card",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-139",
    name: "Chinese Speed Baccarat 3",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-140",
    name: "Mega Sic Bac",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-141",
    name: "Mega Roulette - Brazilian",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-142",
    name: "VIP Auto Roulette",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-143",
    name: "Bet Behind Pro Blackjack",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-144",
    name: "Brazilian ONE Blackjack",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-145",
    name: "Italian Mega Roulette",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-146",
    name: "Indonesian Roulette",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-147",
    name: "Indonesian BlackjackX1",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-148",
    name: "Indonesian BlackjackX2",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-149",
    name: "Indonesian BlackjackX3",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-150",
    name: "Indonesian BlackjackX4",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-151",
    name: "Indonesian BlackjackX5",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-152",
    name: "BlackjackX31",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-153",
    name: "BlackjackX32",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-154",
    name: "BlackjackX33",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-155",
    name: "BlackjackX34",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-156",
    name: "BlackjackX35",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-157",
    name: "BlackjackX36",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-158",
    name: "BlackjackX37",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-159",
    name: "BlackjackX38",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-160",
    name: "BlackjackX39",
  },
  {
    platform: "PP",
    gameType: "LIVE",
    gameCode: "PP-LIVE-161",
    name: "BlackjackX40",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-001",
    name: "Fishin' Reels",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-002",
    name: "Gates of Olympus",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-003",
    name: "Hot to Burn Hold and Spin",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-004",
    name: "Joker King",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-005",
    name: "The Hand of Midas",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-006",
    name: "Eye of the Storm",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-007",
    name: "Dragon Kingdom - Eyes of Fire",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-008",
    name: "Madame Destiny Megaways",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-009",
    name: "Congo Cash",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-010",
    name: "Emerald King Rainbow Road",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-011",
    name: "Mysterious Egypt",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-012",
    name: "Golden Ox",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-013",
    name: "Voodoo Magic",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-014",
    name: "Big Bass Bonanza",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-015",
    name: "Bonanza Gold",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-016",
    name: "John Hunter and the Mayan Gods",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-017",
    name: "Spartan King",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-018",
    name: "Christmas Carol Megaways",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-019",
    name: "Cowboys Gold",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-020",
    name: "Pirate Gold Deluxe",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-021",
    name: "Emerald King",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-022",
    name: "The Dragon Tiger",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-023",
    name: "Book of Kingdoms",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-024",
    name: "Return of the Dead",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-025",
    name: "Gems Bonanza",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-026",
    name: "Wild Walker",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-027",
    name: "Rise of Samurai",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-028",
    name: "5 Lions Dance",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-029",
    name: "Star Bounty",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-030",
    name: "Great Rhino Deluxe",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-031",
    name: "Wild Wild Riches",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-032",
    name: "Ultra Hold and Spin",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-033",
    name: "Curse of the Werewolf Megaways",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-034",
    name: "Jungle Gorilla",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-035",
    name: "Aztec Gems Deluxe",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-036",
    name: "The Dog House Megaways",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-037",
    name: "The Tiger Warrior",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-038",
    name: "Street Racer",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-039",
    name: "Fu Fu Fu",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-040",
    name: "Drago - Jewels of Fortune",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-042",
    name: "Pyramid King",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-043",
    name: "Ultra Burn",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-044",
    name: "Money Money Money",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-045",
    name: "Starz Megaways",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-046",
    name: "Fruit Party",
  },

  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-047",
    name: "John Hunter and the Book of Tut",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-048",
    name: "Three Star Fortune",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-049",
    name: "Great Rhino Megaways",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-050",
    name: "Hot to Burn",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-051",
    name: "Dance Party",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-052",
    name: "Wild West Gold",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-053",
    name: "Lucky Dragon Ball",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-054",
    name: "Fruit Rainbow",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-055",
    name: "The Wild Machine",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-056",
    name: "Aztec Bonanza",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-057",
    name: "Mysterious",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-059",
    name: "Master Joker",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-060",
    name: "Super 7s",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-061",
    name: "Release the Kraken",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-062",
    name: "Buffalo King",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-063",
    name: "Magic Journey",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-064",
    name: "Money Mouse",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-065",
    name: "Aladdin and the Sorcerer",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-066",
    name: "Greek Gods",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-067",
    name: "Sweet Bonanza Xmas",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-068",
    name: "Hercules and Pegasus",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-069",
    name: "Fire Strike",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-070",
    name: "Honey Honey Honey",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-071",
    name: "Super JOKER",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-072",
    name: "John Hunter and the Tomb of the Scarab Queen",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-073",
    name: "Tree of Riches",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-074",
    name: "The Great Chicken Escape",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-075",
    name: "Vampires VS Wolves",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-076",
    name: "Hot Chilli",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-077",
    name: "John Hunter and the Aztec Treasure",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-078",
    name: "Monkey Warrior",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-080",
    name: "5 Lions Gold",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-081",
    name: "Wild Pixies",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-082",
    name: "Sweet Bonanza",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-083",
    name: "Caishen's Cash",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-084",
    name: "Pirate Gold",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-085",
    name: "The Dog House",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-086",
    name: "Egyptian Fortunes",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-087",
    name: "Extra Juicy",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-088",
    name: "Wild Gladiators",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-089",
    name: "Golden Pig",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-090",
    name: "Treasure Horse",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-091",
    name: "Safari King",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-092",
    name: "Leprechaun Carol",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-093",
    name: "Mustang Gold",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-094",
    name: "Triple Dragons",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-095",
    name: "Ancient Egypt Classic",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-096",
    name: "Vegas Magic",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-097",
    name: "Master Chen's Fortune",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-098",
    name: "Da Vinci's Treasure",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-099",
    name: "Peking Luck",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-100",
    name: "Leprechaun Song",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-101",
    name: "Jade Butterfly",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-102",
    name: "Madame Destiny",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-103",
    name: "Asgard",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-104",
    name: "5 Lions",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-106",
    name: "Great Rhino",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-107",
    name: "Joker's Jewels",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-108",
    name: "Fairytale Fortune",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-109",
    name: "Fire 88",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-110",
    name: "Chilli Heat",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-111",
    name: "Aztec Gems",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-112",
    name: "Ancient Egypt",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-113",
    name: "Lucky New Year",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-114",
    name: "Gold Rush",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-115",
    name: "Santa",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-116",
    name: "Panda's Fortune",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-117",
    name: "7 Piggies",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-118",
    name: "Diamond Strike",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-119",
    name: "Vegas Nights",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-120",
    name: "Wild Spells",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-121",
    name: "Caishen's Gold",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-122",
    name: "Pixie Wings",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-123",
    name: "Gold Train",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-125",
    name: "8 Dragons",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-126",
    name: "3 Kingdoms - Battle of Red Cliffs",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-127",
    name: "Wolf Gold",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-131",
    name: "Dragon Kingdom",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-132",
    name: "Hercules Son Of Zeus",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-133",
    name: "3 Genie Wishes",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-135",
    name: "Journey to the West",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-137",
    name: "Lucky Dragons",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-139",
    name: "Dwarven Gold Deluxe",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-141",
    name: "Hot Safari",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-143",
    name: "Mighty Kong",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-144",
    name: "Lady Godiva",
  },

  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-156",
    name: "Great Reef",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-160",
    name: "Devil's 13",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-162",
    name: "Busy Bees",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-163",
    name: "7 Monkeys",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-164",
    name: "Triple Tigers",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-165",
    name: "Monkey Madness",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-166",
    name: "Money Roll",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-167",
    name: "888 Dragons",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-168",
    name: "Irish Charms",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-169",
    name: "888 Gold",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-170",
    name: "Diamonds are Forever 3 Lines",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-171",
    name: "Temujin Treasures",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-172",
    name: "Juicy Fruits",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-173",
    name: "Wild Booster",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-174",
    name: "Power of Thor Megaways",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-175",
    name: "Hot Fiesta",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-176",
    name: "Buffalo King Megaways",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-177",
    name: "Floating Dragon",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-178",
    name: "Panda Fortune 2",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-179",
    name: "Amazing Money Machine",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-180",
    name: "Aztec King",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-181",
    name: "The Magic Cauldron - Enchanted Brew",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-182",
    name: "Cash Elevator",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-183",
    name: "5 Lions Megaways",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-184",
    name: "Dragon Hot Hold and Spin",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-185",
    name: "Yum Yum Powerways",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-186",
    name: "Rise of Giza PowerNudge",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-187",
    name: "Pyramid Bonanza",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-188",
    name: "Raging Bull",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-189",
    name: "Starlight Princess",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-190",
    name: "Bigger Bass Bonanza",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-191",
    name: "Heart of Rio",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-192",
    name: "Lucky Lightning",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-193",
    name: "Empty the Bank",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-194",
    name: "Fruit Party 2",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-195",
    name: "Phoenix Forge",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-196",
    name: "Chicken Drop",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-197",
    name: "Lucky Grace And Charm",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-198",
    name: "Aztec King Megaways",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-199",
    name: "Chilli Heat Megaways",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-200",
    name: "Treasure Wild",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-201",
    name: "Cash Bonanza",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-202",
    name: "Piggy Bank Bills",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-203",
    name: "Day of Dead",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-204",
    name: "Candy Village",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-205",
    name: "Mystic Chief",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-206",
    name: "The Tweety House",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-207",
    name: "Star Pirates Code",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-208",
    name: "John Hunter and the Quest for Bermuda Riches",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-209",
    name: "Big Juan",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-210",
    name: "Santa's Wonderland",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-211",
    name: "Christmas Big Bass Bonanza",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-212",
    name: "Book of Fallen",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-213",
    name: "Bubble Pop™",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-214",
    name: "Bounty Gold",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-215",
    name: "Hockey Attack",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-216",
    name: "Big Bass Bonanza Megaways",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-217",
    name: "Fortune of Giza",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-218",
    name: "Super X",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-219",
    name: "Lucky New Year - Tiger Treasures",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-220",
    name: "Emperor Caishen",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-221",
    name: "Crystal Caverns Megaways",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-222",
    name: "Smugglers Cove",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-223",
    name: "Magician's Secrets",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-224",
    name: "Extra Juicy Megaways",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-225",
    name: "Wild Depths",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-226",
    name: "Gates of Valhalla",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-227",
    name: "Gold Party",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-228",
    name: "Elemental Gems Megaways",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-229",
    name: "Rock Vegas",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-230",
    name: "Cash Patrol",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-231",
    name: "The Ultimate 5",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-232",
    name: "Colossal Cash Zone",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-233",
    name: "Wild West Gold Megaways",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-234",
    name: "Spirit of Adventure",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-235",
    name: "Fire Strike 2",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-236",
    name: "Barn Festival",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-237",
    name: "Chicken Chase",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-238",
    name: "Goblin Heist Powernudge",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-239",
    name: "Eye of Cleopatra",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-240",
    name: "The Great Stick-Up",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-241",
    name: "Book of Aztec King",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-242",
    name: "Bull Fiesta",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-243",
    name: "Might of Ra",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-244",
    name: "Rainbow Gold",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-245",
    name: "Sugar Rush",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-246",
    name: "Snakes and Ladders Megadice",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-247",
    name: "Disco Lady",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-248",
    name: "Tic Tac Take",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-249",
    name: "Queenie",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-250",
    name: "Drill that Gold",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-251",
    name: "Clover Gold",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-252",
    name: "Zombie Carnival",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-253",
    name: "North Guardians",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-254",
    name: "Koi Pond",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-255",
    name: "Cleocatra",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-256",
    name: "Little Gem",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-257",
    name: "Queen of Gods",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-258",
    name: "Cosmic Cash",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-259",
    name: "Bomb Bonanza",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-260",
    name: "Mahjong Panda",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-261",
    name: "Big Bass Splash",
  },
  {
    platform: "PP",
    gameType: "SLOT",
    gameCode: "PP-SLOT-262",
    name: "Tropical Tiki",
  },
];

export const PT = [
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-001",
    name: "Baccarat",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-002",
    name: "Dragon Tiger",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-003",
    name: "SicBo Deluxe",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-004",
    name: "Andar Bahar Live",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-005",
    name: "Bet on Baccarat Live",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-007",
    name: "All Bets Blackjack",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-008",
    name: "Majority Rules Speed Blackjack",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-009",
    name: "Sette E Mezzo",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-010",
    name: "Unlimited Blackjack",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-011",
    name: "Adventures Beyond Wonderland",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-014",
    name: "Hi-Lo",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-015",
    name: "Spin a Win",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-016",
    name: "3 Card Brag",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-017",
    name: "Casino Hold´em",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-019",
    name: "Bet on Poker Live",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-021",
    name: "American Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-022",
    name: "Deutsches Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-023",
    name: "Football French Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-024",
    name: "Football Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-025",
    name: "French Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-026",
    name: "Quantum Auto Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-027",
    name: "Spread Bet Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-028",
    name: "Mega Fire Blaze Roulette Live",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-030",
    name: "Bet On Dragon Tiger Live",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-031",
    name: "Italian Cashback Blackjack",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-032",
    name: "Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-034",
    name: "Grand Baccarat",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-035",
    name: "Speed 6 Scanner Baccarat",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-037",
    name: "Grand Baccarat NC",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-038",
    name: "Speed 6 Scanner Baccarat NC",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-041",
    name: "Blackjack Italiano 1",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-042",
    name: "Blackjack Italiano 2",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-043",
    name: "Blackjack Italiano VIP",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-044",
    name: "Deutsches Blackjack",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-045",
    name: "Royale Blackjack 1",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-051",
    name: "Grand Blackjack",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-052",
    name: "Royale Blackjack 3",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-054",
    name: "Soho All Bets Blackjack",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-055",
    name: "Greek Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-056",
    name: "Hindi Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-057",
    name: "Prestige Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-058",
    name: "Speed Auto Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-059",
    name: "Roleta Brasileira",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-060",
    name: "Roulette Italiana",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-061",
    name: "Auto Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-062",
    name: "Speed Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-063",
    name: "Bucharest Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-064",
    name: "Turkish Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-066",
    name: "Bucharest French Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-067",
    name: "Quantum Roulette Live",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-068",
    name: "Blackjack 9",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-069",
    name: "Blackjack 3",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-070",
    name: "Blackjack 4",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-071",
    name: "Blackjack 5",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-072",
    name: "Blackjack 6",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-073",
    name: "Blackjack 7",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-074",
    name: "Blackjack 8",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-075",
    name: "Baccarat NC",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-076",
    name: "Greek Quantum Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-077",
    name: "Ruleta Automatica Cuantica",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-078",
    name: "Arabic Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-079",
    name: "Quantum Ruleta España",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-080",
    name: "Ruyi French Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-081",
    name: "Ruyi Roulette",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-083",
    name: "Slingshot Ruleta Espana",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-086",
    name: "The Greatest Cards Show",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-087",
    name: "Teen Patti Live",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-088",
    name: "Spin a Win Wild Live",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-090",
    name: "Big Bad Wolf Live",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-091",
    name: "Japanese Squeeze Baccarat",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-092",
    name: "Japanese Squeeze Baccarat NC",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-093",
    name: "Ru Yi Speed Baccarat",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-094",
    name: "Ru Yi Speed Baccarat NC",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-095",
    name: "Speed Baccarat Korean",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-096",
    name: "Speed Baccarat Korean NC",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-097",
    name: "Baccarat Brasileira",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-098",
    name: "Baccarat Brasileira NC",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-099",
    name: "Speed SicBo",
  },
  {
    platform: "PT",
    gameType: "LIVE",
    gameCode: "PT-LIVE-100",
    name: "Auto Roulette 2",
  },
];

export const Spade = [
  {
    platform: "SPADE",
    gameType: "EGAME",
    gameCode: "SG-EGAME-003",
    name: "Space Crasher",
  },
  {
    platform: "SPADE",
    gameType: "FH",
    gameCode: "SG-FISH-001",
    name: "Fishing God",
  },
  {
    platform: "SPADE",
    gameType: "FH",
    gameCode: "SG-FISH-002",
    name: "Fishing War",
  },
  {
    platform: "SPADE",
    gameType: "FH",
    gameCode: "SG-FISH-003",
    name: "Alien Hunter",
  },
  {
    platform: "SPADE",
    gameType: "FH",
    gameCode: "SG-FISH-004",
    name: "Zombie Party",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-001",
    name: "Candy Pop",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-003",
    name: "FaFaFa2",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-005",
    name: "PrincessWang",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-006",
    name: "WowProsperity",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-008",
    name: "FirstLove",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-009",
    name: "GoldenMonkey",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-012",
    name: "JungleKing",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-014",
    name: "TigerWarrior",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-016",
    name: "ZEUS",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-017",
    name: "HoYeahMonkey",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-018",
    name: "GoldenChicken",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-019",
    name: "DragonGoldSA",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-021",
    name: "BigProsperitySA",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-022",
    name: "GreatStarsSA",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-023",
    name: "IcelandSA",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-030",
    name: "5FortuneSA",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-031",
    name: "BabyCaiShen",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-032",
    name: "GoldenLotusSE",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-034",
    name: "KingPharaoh",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-037",
    name: "CaiShen888",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-038",
    name: "DoubleFortunes",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-039",
    name: "5FortuneDragons",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-041",
    name: "LuckyKoi",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-045",
    name: "Fafafa",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-046",
    name: "LuckyFengShui",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-049",
    name: "HighwayFortune",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-055",
    name: "DaFuXiaoFu",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-058",
    name: "GoldenWhale",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-060",
    name: "LuckyMeow",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-068",
    name: "HeroesGame",
  },
  { platform: "SPADE", gameType: "SLOT", gameCode: "SG-SLOT-069", name: "888" },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-070",
    name: "DancingFever",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-071",
    name: "MoneyMouse",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-072",
    name: "SweetBakery",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-073",
    name: "ThreeLuckyStars",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-074",
    name: "Mega7",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-075",
    name: "JokersTreasure",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-076",
    name: "DoubleFlame",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-077",
    name: "BookofMyth",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-078",
    name: "CrazyBomber",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-079",
    name: "FierySevens",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-080",
    name: "MagicalLamp",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-081",
    name: "TriplePanda",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-082",
    name: "GoldPanther",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-083",
    name: "MrChuTycoon",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-084",
    name: "BrothersKingdom",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-085",
    name: "ProsperityGods",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-086",
    name: "Mayan Gems",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-087",
    name: "Rise Of Werewolves",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-089",
    name: "Hugon Quest",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-091",
    name: "Magic Kitty",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-092",
    name: "Sugar Bonanza",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-093",
    name: "Love Idol",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-095",
    name: "Poker Ways",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-096",
    name: "Rich Caishen",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-097",
    name: "Muay Thai Fighter",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-098",
    name: "Royal Katt",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-099",
    name: "Wild Wet Win",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-100",
    name: "Gold Rush Cowboy",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-101",
    name: "Candy Candy",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-102",
    name: "Roma",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-103",
    name: "Sexy Vegas",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-104",
    name: "Tiger Dance",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-105",
    name: "Royale House",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-106",
    name: "Fiery Sevens Exclusive",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-107",
    name: "Lucky Koi Exclusive",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-108",
    name: "Joker's Treasure Exclusive",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-109",
    name: "Caishen",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-110",
    name: "Space Conquest",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-111",
    name: "Gold Panther Maxways",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-112",
    name: "Fruits Mania",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-113",
    name: "Journey to the Wild",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-114",
    name: "Captain Golds Fortune",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-115",
    name: "Sugar Party",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-116",
    name: "Legacy Of Kong Maxways",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-117",
    name: "Halloween Vacation",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-119",
    name: "Christmas Miracles",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-120",
    name: "Rabbit Riches",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-121",
    name: "CAISHEN DELUXE MAXWAYS",
  },

  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-122",
    name: "Farmland Frenzy Maxways",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-123",
    name: "Candy Pop 2",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-124",
    name: "Hammer of Thunder",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-126",
    name: "Gemstone Rush",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-127",
    name: "Moji Mania",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-139",
    name: "Clash of the Giants",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-140",
    name: "Royale Vegas",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-141",
    name: "Dragon Wish",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-142",
    name: "Galaxy Guardian",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-143",
    name: "Brothers Kingdom 2",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-144",
    name: "Secrets of Anubis",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-145",
    name: "Alchemy Quest Level Up",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-146",
    name: "Fury Max Lucky Road",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-147",
    name: "Lucky Twin Sea",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-148",
    name: "Gold West",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-149",
    name: "Happy Neko",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-150",
    name: "Fruit Ninja Fury",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-151",
    name: "Santa Wild Drop",
  },
  {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-152",
    name: "Lucky Snake Wheel",
  },
];

export const Spribe = [
  {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-001",
    name: "Aviator",
  },
  {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-002",
    name: "Goal",
  },
  {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-003",
    name: "Dice",
  },
  {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-004",
    name: "Plinko",
  },
  {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-005",
    name: "Mines",
  },
  {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-006",
    name: "Hilo",
  },
  {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-007",
    name: "Keno",
  },
  {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-008",
    name: "Mini Roulette",
  },
  {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-009",
    name: "Hotline",
  },
];

export const Egame = [
  {
    platform: "YL",
    gameType: "FH",
    gameCode: "YL-FISH-001",
    name: "Fishing 2",
  },
  {
    platform: "YL",
    gameType: "FH",
    gameCode: "YL-FISH-002",
    name: "Shark Hunter",
  },
  {
    platform: "YL",
    gameType: "FH",
    gameCode: "YL-FISH-003",
    name: "New Fishing Season",
  },
  {
    platform: "YL",
    gameType: "FH",
    gameCode: "YL-FISH-004",
    name: "Jackpot Fishery",
  },
  {
    platform: "YL",
    gameType: "FH",
    gameCode: "YL-FISH-005",
    name: "Heroes of the Deep Sea",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-001",
    name: "Fruit",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-002",
    name: "Gold Shark",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-003",
    name: "Shark",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-004",
    name: "Forest Dance",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-005",
    name: "Happy Fruit",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-006",
    name: "Cockfighting",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-007",
    name: "Solo king",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-008",
    name: "Lucky five",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-009",
    name: "PokerGo",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-010",
    name: "DiamondDeal",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-011",
    name: "Mercedes-Benz BMW",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-012",
    name: "Guess",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-013",
    name: "Mines",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-014",
    name: "Tower",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-015",
    name: "Ojisan",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-016",
    name: "Crash",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-017",
    name: "Dice",
  },
  {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-018",
    name: "Plinko",
  },
];

export const EgameObject = {
  "YL-FISH-001": {
    platform: "YL",
    gameType: "FH",
    gameCode: "YL-FISH-001",
    name: "Fishing 2",
    status: "off",
  },
  "YL-FISH-002": {
    platform: "YL",
    gameType: "FH",
    gameCode: "YL-FISH-002",
    name: "Shark Hunter",
    status: "off",
  },
  "YL-FISH-003": {
    platform: "YL",
    gameType: "FH",
    gameCode: "YL-FISH-003",
    name: "New Fishing Season",
    status: "off",
  },
  "YL-FISH-004": {
    platform: "YL",
    gameType: "FH",
    gameCode: "YL-FISH-004",
    name: "Jackpot Fishery",
    status: "off",
  },
  "YL-FISH-005": {
    platform: "YL",
    gameType: "FH",
    gameCode: "YL-FISH-005",
    name: "Heroes of the Deep Sea",
    status: "off",
  },
  "YL-EGAME-001": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-001",
    name: "Fruit",
    status: "off",
  },
  "YL-EGAME-002": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-002",
    name: "Gold Shark",
    status: "off",
  },
  "YL-EGAME-003": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-003",
    name: "Shark",
    status: "off",
  },
  "YL-EGAME-004": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-004",
    name: "Forest Dance",
    status: "off",
  },
  "YL-EGAME-005": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-005",
    name: "Happy Fruit",
    status: "off",
  },
  "YL-EGAME-006": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-006",
    name: "Cockfighting",
    status: "off",
  },
  "YL-EGAME-007": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-007",
    name: "Solo king",
    status: "off",
  },
  "YL-EGAME-008": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-008",
    name: "Lucky five",
    status: "off",
  },
  "YL-EGAME-009": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-009",
    name: "PokerGo",
    status: "off",
  },
  "YL-EGAME-010": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-010",
    name: "DiamondDeal",
    status: "off",
  },
  "YL-EGAME-011": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-011",
    name: "Mercedes-Benz BMW",
    status: "off",
  },
  "YL-EGAME-012": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-012",
    name: "Guess",
    status: "off",
  },
  "YL-EGAME-013": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-013",
    name: "Mines",
    status: "off",
  },
  "YL-EGAME-014": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-014",
    name: "Tower",
    status: "off",
  },
  "YL-EGAME-015": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-015",
    name: "Ojisan",
    status: "off",
  },
  "YL-EGAME-016": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-016",
    name: "Crash",
    status: "off",
  },
  "YL-EGAME-017": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-017",
    name: "Dice",
    status: "off",
  },
  "YL-EGAME-018": {
    platform: "YL",
    gameType: "EGAME",
    gameCode: "YL-EGAME-018",
    name: "Plinko",
    status: "off",
  },
};
export const SpribeObject = {
  "SPRIBE-EGAME-001": {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-001",
    name: "Aviator",
    status: "off",
  },
  "SPRIBE-EGAME-002": {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-002",
    name: "Goal",
    status: "off",
  },
  "SPRIBE-EGAME-003": {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-003",
    name: "Dice",
    status: "off",
  },
  "SPRIBE-EGAME-004": {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-004",
    name: "Plinko",
    status: "off",
  },
  "SPRIBE-EGAME-005": {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-005",
    name: "Mines",
    status: "off",
  },
  "SPRIBE-EGAME-006": {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-006",
    name: "Hilo",
    status: "off",
  },
  "SPRIBE-EGAME-007": {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-007",
    name: "Keno",
    status: "off",
  },
  "SPRIBE-EGAME-008": {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-008",
    name: "Mini Roulette",
    status: "off",
  },
  "SPRIBE-EGAME-009": {
    platform: "SPRIBE",
    gameType: "EGAME",
    gameCode: "SPRIBE-EGAME-009",
    name: "Hotline",
    status: "off",
  },
};

export const SpadeObject = {
  "SG-EGAME-003": {
    platform: "SPADE",
    gameType: "EGAME",
    gameCode: "SG-EGAME-003",
    name: "Space Crasher",
    status: "off",
  },
  "SG-FISH-001": {
    platform: "SPADE",
    gameType: "FH",
    gameCode: "SG-FISH-001",
    name: "Fishing God",
    status: "off",
  },
  "SG-FISH-002": {
    platform: "SPADE",
    gameType: "FH",
    gameCode: "SG-FISH-002",
    name: "Fishing War",
    status: "off",
  },
  "SG-FISH-003": {
    platform: "SPADE",
    gameType: "FH",
    gameCode: "SG-FISH-003",
    name: "Alien Hunter",
    status: "off",
  },
  "SG-FISH-004": {
    platform: "SPADE",
    gameType: "FH",
    gameCode: "SG-FISH-004",
    name: "Zombie Party",
    status: "off",
  },
  "SG-SLOT-001": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-001",
    name: "Candy Pop",
    status: "off",
  },
  "SG-SLOT-003": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-003",
    name: "FaFaFa2",
    status: "off",
  },
  "SG-SLOT-005": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-005",
    name: "PrincessWang",
    status: "off",
  },
  "SG-SLOT-006": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-006",
    name: "WowProsperity",
    status: "off",
  },
  "SG-SLOT-008": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-008",
    name: "FirstLove",
    status: "off",
  },
  "SG-SLOT-009": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-009",
    name: "GoldenMonkey",
    status: "off",
  },
  "SG-SLOT-012": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-012",
    name: "JungleKing",
    status: "off",
  },
  "SG-SLOT-014": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-014",
    name: "TigerWarrior",
    status: "off",
  },
  "SG-SLOT-016": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-016",
    name: "ZEUS",
    status: "off",
  },
  "SG-SLOT-017": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-017",
    name: "HoYeahMonkey",
    status: "off",
  },
  "SG-SLOT-018": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-018",
    name: "GoldenChicken",
    status: "off",
  },
  "SG-SLOT-019": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-019",
    name: "DragonGoldSA",
    status: "off",
  },
  "SG-SLOT-021": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-021",
    name: "BigProsperitySA",
    status: "off",
  },
  "SG-SLOT-022": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-022",
    name: "GreatStarsSA",
    status: "off",
  },
  "SG-SLOT-023": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-023",
    name: "IcelandSA",
    status: "off",
  },
  "SG-SLOT-030": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-030",
    name: "5FortuneSA",
    status: "off",
  },
  "SG-SLOT-031": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-031",
    name: "BabyCaiShen",
    status: "off",
  },
  "SG-SLOT-032": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-032",
    name: "GoldenLotusSE",
    status: "off",
  },
  "SG-SLOT-034": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-034",
    name: "KingPharaoh",
    status: "off",
  },
  "SG-SLOT-037": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-037",
    name: "CaiShen888",
    status: "off",
  },
  "SG-SLOT-038": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-038",
    name: "DoubleFortunes",
    status: "off",
  },
  "SG-SLOT-039": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-039",
    name: "5FortuneDragons",
    status: "off",
  },
  "SG-SLOT-041": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-041",
    name: "LuckyKoi",
    status: "off",
  },
  "SG-SLOT-045": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-045",
    name: "Fafafa",
    status: "off",
  },
  "SG-SLOT-046": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-046",
    name: "LuckyFengShui",
    status: "off",
  },
  "SG-SLOT-049": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-049",
    name: "HighwayFortune",
    status: "off",
  },
  "SG-SLOT-055": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-055",
    name: "DaFuXiaoFu",
    status: "off",
  },
  "SG-SLOT-058": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-058",
    name: "GoldenWhale",
    status: "off",
  },
  "SG-SLOT-060": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-060",
    name: "LuckyMeow",
    status: "off",
  },
  "SG-SLOT-068": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-068",
    name: "HeroesGame",
    status: "off",
  },
  "SG-SLOT-069": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-069",
    name: "888",
    status: "off",
  },
  "SG-SLOT-070": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-070",
    name: "DancingFever",
    status: "off",
  },
  "SG-SLOT-071": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-071",
    name: "MoneyMouse",
    status: "off",
  },
  "SG-SLOT-072": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-072",
    name: "SweetBakery",
    status: "off",
  },
  "SG-SLOT-073": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-073",
    name: "ThreeLuckyStars",
    status: "off",
  },
  "SG-SLOT-074": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-074",
    name: "Mega7",
    status: "off",
  },
  "SG-SLOT-075": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-075",
    name: "JokersTreasure",
    status: "off",
  },
  "SG-SLOT-076": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-076",
    name: "DoubleFlame",
    status: "off",
  },
  "SG-SLOT-077": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-077",
    name: "BookofMyth",
    status: "off",
  },
  "SG-SLOT-078": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-078",
    name: "CrazyBomber",
    status: "off",
  },
  "SG-SLOT-079": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-079",
    name: "FierySevens",
    status: "off",
  },
  "SG-SLOT-080": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-080",
    name: "MagicalLamp",
    status: "off",
  },
  "SG-SLOT-081": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-081",
    name: "TriplePanda",
    status: "off",
  },
  "SG-SLOT-082": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-082",
    name: "GoldPanther",
    status: "off",
  },
  "SG-SLOT-083": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-083",
    name: "MrChuTycoon",
    status: "off",
  },
  "SG-SLOT-084": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-084",
    name: "BrothersKingdom",
    status: "off",
  },
  "SG-SLOT-085": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-085",
    name: "ProsperityGods",
    status: "off",
  },
  "SG-SLOT-086": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-086",
    name: "Mayan Gems",
    status: "off",
  },
  "SG-SLOT-087": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-087",
    name: "Rise Of Werewolves",
    status: "off",
  },
  "SG-SLOT-089": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-089",
    name: "Hugon Quest",
    status: "off",
  },
  "SG-SLOT-091": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-091",
    name: "Magic Kitty",
    status: "off",
  },
  "SG-SLOT-092": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-092",
    name: "Sugar Bonanza",
    status: "off",
  },
  "SG-SLOT-093": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-093",
    name: "Love Idol",
    status: "off",
  },
  "SG-SLOT-095": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-095",
    name: "Poker Ways",
    status: "off",
  },
  "SG-SLOT-096": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-096",
    name: "Rich Caishen",
    status: "off",
  },
  "SG-SLOT-097": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-097",
    name: "Muay Thai Fighter",
    status: "off",
  },
  "SG-SLOT-098": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-098",
    name: "Royal Katt",
    status: "off",
  },
  "SG-SLOT-099": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-099",
    name: "Wild Wet Win",
    status: "off",
  },
  "SG-SLOT-100": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-100",
    name: "Gold Rush Cowboy",
    status: "off",
  },
  "SG-SLOT-101": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-101",
    name: "Candy Candy",
    status: "off",
  },
  "SG-SLOT-102": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-102",
    name: "Roma",
    status: "off",
  },
  "SG-SLOT-103": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-103",
    name: "Sexy Vegas",
    status: "off",
  },
  "SG-SLOT-104": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-104",
    name: "Tiger Dance",
    status: "off",
  },
  "SG-SLOT-105": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-105",
    name: "Royale House",
    status: "off",
  },
  "SG-SLOT-106": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-106",
    name: "Fiery Sevens Exclusive",
    status: "off",
  },
  "SG-SLOT-107": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-107",
    name: "Lucky Koi Exclusive",
    status: "off",
  },
  "SG-SLOT-108": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-108",
    name: "Joker's Treasure Exclusive",
    status: "off",
  },
  "SG-SLOT-109": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-109",
    name: "Caishen",
    status: "off",
  },
  "SG-SLOT-110": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-110",
    name: "Space Conquest",
    status: "off",
  },
  "SG-SLOT-111": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-111",
    name: "Gold Panther Maxways",
    status: "off",
  },
  "SG-SLOT-112": {
    platform: "SPADE",
    gameType: "SLOT",
    gameCode: "SG-SLOT-112",
  },
};
